import React from 'react';
import FormsySimpleInput from '../form/FormsySimpleInput';

const HeadingPlaceholder = props => {
  const { value, placeholder, label, name, onChange, isEdit = false } = props;

  if (isEdit) return renderEdit(value, placeholder, label, name, onChange);
  else return renderView(value, placeholder, label);
};

const renderEdit = (value, placeholder, label, name, onChange) => {
  return (
    <div className="heading-placeholder">
      <p className="simple-input__label">{label}</p>
      <FormsySimpleInput
        type="text"
        name={name}
        placeholder={placeholder}
        required
        value={value}
        onChange={onChange}
        autoComplete="off"
      />
    </div>
  );
};

const renderView = (value, placeholder, label) => {
  if (value && value !== '')
    return (
      <div className="heading-placeholder">
        <p className="p heading-placeholder__label">{label}</p>
        <h1 className="h2 heading-placeholder__heading">{value}</h1>
      </div>
    );
  else
    return (
      <div className="heading-placeholder">
        <h1 className="h2 heading-placeholder__h1">{label}</h1>
      </div>
    );
};

export default HeadingPlaceholder;



// WEBPACK FOOTER //
// ./src/components/shared/HeadingPlaceholder.js